import { ApiActionTypes, buildApiTypeAction } from "src/common/apiLoader/apiLoaderUtils";

const GET_USERS = 'GET_USERS';
export const GET_USERS_API = buildApiTypeAction(GET_USERS, ApiActionTypes.REQUEST)
export const GET_USERS_API_SUCCESS = buildApiTypeAction(GET_USERS, ApiActionTypes.SUCCESS)
export const GET_USERS_API_ERROR = buildApiTypeAction(GET_USERS, ApiActionTypes.ERROR)

const UPSERT_USER = 'UPSERT_USER';
export const UPSERT_USER_API = buildApiTypeAction(UPSERT_USER, ApiActionTypes.REQUEST)
export const UPSERT_USER_API_SUCCESS = buildApiTypeAction(UPSERT_USER, ApiActionTypes.SUCCESS)
export const UPSERT_USER_API_ERROR = buildApiTypeAction(UPSERT_USER, ApiActionTypes.ERROR)

const GET_USER_ROLES = 'GET_USER_ROLES';
export const GET_USER_ROLES_API = buildApiTypeAction(GET_USER_ROLES, ApiActionTypes.REQUEST)
export const GET_USER_ROLES_API_SUCCESS = buildApiTypeAction(GET_USER_ROLES, ApiActionTypes.SUCCESS)
export const GET_USER_ROLES_API_ERROR = buildApiTypeAction(GET_USER_ROLES, ApiActionTypes.ERROR)

const GET_USER_BY_ID = 'GET_USER_BY_ID';
export const GET_USER_BY_ID_API = buildApiTypeAction(GET_USER_BY_ID, ApiActionTypes.REQUEST)
export const GET_USER_BY_ID_API_SUCCESS = buildApiTypeAction(GET_USER_BY_ID, ApiActionTypes.SUCCESS)
export const GET_USER_BY_ID_API_ERROR = buildApiTypeAction(GET_USER_BY_ID, ApiActionTypes.ERROR)

const UPDATE_USER_PASSWORD = 'UPDATE_USER_PASSWORD';
export const UPDATE_USER_PASSWORD_API = buildApiTypeAction(UPDATE_USER_PASSWORD, ApiActionTypes.REQUEST)
export const UPDATE_USER_PASSWORD_API_SUCCESS = buildApiTypeAction(UPDATE_USER_PASSWORD, ApiActionTypes.SUCCESS)
export const UPDATE_USER_PASSWORD_API_ERROR = buildApiTypeAction(UPDATE_USER_PASSWORD, ApiActionTypes.ERROR)

export const CLEAN_CURRENT_USER = 'CLEAN_CURRENT_USER';
